import { takeLeading, call, put, getContext } from "redux-saga/effects";
import { requestInitializeLogin, createLogoutAction, createSuccessGateLoginAction, createSuccessAnonLoginAction, createFailureLoginAction } from "./authActions";
import { TResult } from "../../../../sg-core";
import IHavainnotUser from "../../interfaces/IHavainnotUser";
import { ISgAuthService, ILoginResult } from "../../../../sg-auth/services/SgAuthService";
import { apiService } from "../../../store";
import { IContextService } from "../../services/contextService";
import { parseQuery } from "../../utils/query.helper";
import { IObservationService } from "../../services/observationService";
import { default as JSCookies } from "js-cookie";
import { ICommonService } from "../../../../@common/services/CommonService";
import { AUTH_COOKIE, RETURN_HREF_COOKIE } from "../../../../@common/constants/StorageKeys";
import { getCookie, setCookie } from "../../../../@common/hooks/useCookie";

const createInitializeSaga = (auth: ISgAuthService) =>
    function* saga() {
        try {

            const { search, pathname } = window.location;


            const guery = parseQuery<{ lang?: string }>(window.location.search) as any;


            // Handle print
            const anonTokenRegex = /\?id=([A-Za-z0-9-_]+)&?$/g;
            const anonTokenRegexResult = anonTokenRegex.exec(search);
            if (anonTokenRegexResult !== null && pathname.indexOf("tulosta") > -1) {

                const [_1, observationToken] = anonTokenRegexResult;
                const commonService: ICommonService = yield getContext("common");
                const authService: ISgAuthService = yield getContext("auth");
                const loginResponse: TResult<{ data: any, token: string }> = yield call(commonService.getPackageWithReadonlySession, observationToken)
                //@ts-ignore
                if (loginResponse.isFailure) return yield put(createLogoutAction());
                const token = loginResponse.value.token
                apiService.setToken(token);

                if (guery.lang) {
                    const languageResult: TResult<any> = yield call(authService.changeSessionLanguage, guery.lang, token)
                }

                yield put(createSuccessAnonLoginAction(token, loginResponse.value.data));
                return
            };

            // Handle anonymous form
            const anonFormRegex = /anonyymilomake\/([A-Za-z0-9-_]+)&?$/g;
            const anonFormRegexResult = anonFormRegex.exec(pathname);

            if (anonFormRegexResult !== null && pathname.indexOf("anonyymilomake") > -1) {
                const [_1, formGuid] = anonFormRegexResult;
                const contextService: IContextService = yield getContext("context");
                const loginResponse: TResult<{ formTypeId: any, token: string }> = yield call(contextService.getAnonymousForm, formGuid);
                //@ts-ignore
                if (loginResponse.isFailure) return yield put(createLogoutAction());
                const token = loginResponse.value.token
                apiService.setToken(token)

                if (guery.lang) {
                    const authService: ISgAuthService = yield getContext("auth");
                    const languageResult: TResult<any> = yield call(authService.changeSessionLanguage, guery.lang, token)
                };

                yield put(createSuccessAnonLoginAction(token, loginResponse.value.formTypeId));
                return
            }


            // Handle anonymous path
            const anonRegex = /anonyymi\/havainto\/([A-Za-z0-9-_]+)&?$/g;
            const anonRegexResult = anonRegex.exec(pathname);

            if (anonRegexResult !== null && pathname.indexOf("anonyymi") > -1) {
                const [_1, packageId] = anonRegexResult;
                const observationService: IObservationService = yield getContext("observation");
                const loginResponse: TResult<{ data: any, token: string }> = yield call(observationService.getHistoryDataAnonym, packageId);
                //@ts-ignore
                if (loginResponse.isFailure) return yield put(createLogoutAction());
                const token = loginResponse.value.token;
                apiService.setToken(token);

                if (guery.lang) {
                    const authService: ISgAuthService = yield getContext("auth");
                    const languageResult: TResult<any> = yield call(authService.changeSessionLanguage, guery.lang, token)
                };

                yield put(createSuccessAnonLoginAction(token, loginResponse.value.data));
                return
            }


            if (window.location.href.indexOf("token") > -1) {
                const loginResponse: TResult<ILoginResult> = yield call(auth.activateTokenViaParam);
                if (loginResponse.isSuccess === true) {
                    const { token, user, returnHref, apiLanguage, applicationGuid } = loginResponse.value;
                    const lang = guery.lang || loginResponse.value.user.language;
                    apiService.setToken(token);
                    if (lang !== apiLanguage) {
                        const authService: ISgAuthService = yield getContext("auth");
                        const languageResult: TResult<any> = yield call(authService.changeSessionLanguage, lang, token)
                    }
                    setCookie(AUTH_COOKIE, token, { expires: 7, sameSite: "lax" });
                    setCookie(RETURN_HREF_COOKIE, returnHref, { expires: 7, sameSite: "lax" });
                    JSCookies.set("rdr", applicationGuid, { path: process.env.PUBLIC_URL, sameSite: "lax" });
                    yield put(createSuccessGateLoginAction(token, user as IHavainnotUser, returnHref, lang, applicationGuid));
                    return
                };
            }



            const authCookie = getCookie(AUTH_COOKIE);

            if (authCookie.isFailure) {
                throw authCookie.error
            };

            const storedSid = authCookie.value as string;
            // Attempt to initialize with gate token in url.
            const loginResponse: TResult<ILoginResult> = yield call(auth.fetchSessionDetail, storedSid);

            if (loginResponse.isSuccess === true) {
                const { user, apiLanguage, applicationGuid } = loginResponse.value;
                const lang = guery.lang || loginResponse.value.user.language;
                apiService.setToken(storedSid);

                const returnHrefResult = getCookie(RETURN_HREF_COOKIE);
                const returnHref = returnHrefResult.isSuccess ? returnHrefResult.value : undefined
                if (lang !== apiLanguage) {
                    const authService: ISgAuthService = yield getContext("auth");
                    const languageResult: TResult<any> = yield call(authService.changeSessionLanguage, lang, storedSid)
                }
                setCookie(AUTH_COOKIE, storedSid, { expires: 7, sameSite: "lax" });
                JSCookies.set("rdr", applicationGuid, { path: process.env.PUBLIC_URL, sameSite: "lax" });
                yield put(createSuccessGateLoginAction(storedSid, user as IHavainnotUser, returnHref, lang, applicationGuid));
                return
            };


            // ...Other initial logging cases here


            yield put(createLogoutAction());
        } catch (e) {
            console.log(e)
            yield put(createFailureLoginAction(e as Error));
        }
    };

export default function (auth: ISgAuthService) {
    return takeLeading(
        requestInitializeLogin,
        createInitializeSaga(auth),
    );
}
